import { render, staticRenderFns } from "./WhyChooseSection.vue?vue&type=template&id=1c7fa6c9&scoped=true"
import script from "./WhyChooseSection.vue?vue&type=script&lang=js"
export * from "./WhyChooseSection.vue?vue&type=script&lang=js"
import style0 from "./WhyChooseSection.vue?vue&type=style&index=0&id=1c7fa6c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7fa6c9",
  null
  
)

export default component.exports